var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCircleSuccessBlack(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "104px",
    height: "104px",
    viewBox: "0 0 104 104",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icCircleSuccessBlack") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Congratulations",
    transform: "translate(-649.000000, -268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(501.000000, 230.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icCircleSuccessBlack",
    transform: "translate(150.000000, 40.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5555556,49.7791052 C99.5555556,22.3621015 77.1961089,0 49.7791052,0 C22.3621015,0 0,22.3621015 0,49.7791052 C0,77.1961089 22.3621015,99.5555556 49.7791052,99.5555556 C77.1961089,99.5555556 99.5555556,77.1961089 99.5555556,49.7791052 Z",
    id: "Fill-3",
    stroke: "#000000",
    strokeWidth: 3
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-5",
    fill: "#000000",
    points: "67.0608055 30.2716049 42.1719166 54.7255901 32.4924588 45.2182716 24.8888889 52.6932938 42.1719166 69.6790123 74.6666667 37.7466272"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCircleSuccessBlack);
export default __webpack_public_path__ + "static/media/icCircleSuccessBlack.b27548943e8828ab56bd4102eb64a854.svg";
export { ForwardRef as ReactComponent };